import { useQuery } from '@apollo/client';
import { useMaOpportunitiesContext } from '../../../MaOpportunitiesContext';
import { MA_OPPORTUNITIES_QUERY } from '../operations';

export const useGetMaOpportunities = (page, perPage, order, orderBy) => {
  const { filterVariables } = useMaOpportunitiesContext();
  const pagination = {
    page: page + 1,
    perPage,
    order,
    orderBy,
  };

  const { loading, error, data, previousData } = useQuery(MA_OPPORTUNITIES_QUERY, {
    variables: { filters: filterVariables, pagination },
  });

  return {
    data:
      data?.maOpportunities?.opportunities || previousData?.maOpportunities?.opportunities || [],
    totalCount: data?.maOpportunities?.totalCount,
    loading,
    error,
  };
};
